"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shadows = void 0;
exports.shadows = {
    tiny: '0 1px 1px rgba(0, 0, 0, 0.11)',
    small: '0 1px 4px rgba(0, 0, 0, 0.05)',
    medium: '0 1px 1px rgba(0, 0, 0, 0.05), 0 4px 14px rgba(0, 0, 0, 0.08)',
};
//# sourceMappingURL=shadows.js.map